import c from "./index841.js";
var i = 500;
function m(a) {
  var e = c(a, function(t) {
    return r.size === i && r.clear(), t;
  }), r = e.cache;
  return e;
}
export {
  m as default
};
